import script from "./proportionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./proportionChart.vue?vue&type=script&setup=true&lang=js"

import "./proportionChart.vue?vue&type=style&index=0&id=90cf0b3e&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/h-waterwork-storeroom-webui_prev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90cf0b3e"]])

export default __exports__